import gsap from 'gsap';
import Animation from './animation';

export default class Scroll {
    constructor() {
        // console.info('Scroll.constructor()');

        this.config = {
            selector: '[data-skroll]',
        };

        this.el = {
            container: document.body,
            elements: [],
        };

        this.scrollElements = [];

        this.init();
    }

    init() {
        // console.info('Scroll.init()');

        this.el.elements = this.el.container.querySelectorAll(this.config.selector);

        for (let i = 0; i < this.el.elements.length; i += 1) {
            const element = this.el.elements[i];
            this.createScrollElement(element, i);
        }
    }

    createScrollElement(el, index) {
        // console.info(`Scroll.createScrollElement(${el}, ${index})`);

        let refs = null;

        if (!el) return;

        // Cache children elements
        if (el.dataset.skroll === 'alternating-panels') {
            const childrenPicture = el.querySelectorAll('[data-skroll-picture]');

            refs = {
                parent: el.parentNode,
                childrenPicture,
            };
        } else if (el.dataset.skroll === 'split-hero-block-left') {
            const childrenPicture = el.querySelectorAll('[data-skroll-picture]');

            refs = {
                parent: el.parentNode,
                childrenPicture,
            };
        } else if (el.dataset.skroll === 'split-hero-block-right') {
            const childrenPicture = el.querySelectorAll('[data-skroll-picture]');

            refs = {
                parent: el.parentNode,
                childrenPicture,
            };
        }

        let scrollOptions = {};

        if (el.dataset.skroll === 'alternating-panels') {
            scrollOptions = {
                animation: gsap.fromTo(
                    refs.childrenPicture,
                    {
                        y: 100,
                        opacity: 0,
                    },
                    {
                        duration: 1,
                        y: 0,
                        opacity: 1.0,
                        ease: 'easeGarret',
                    }
                ),
            };
        } else if (el.dataset.skroll === 'split-hero-block-left') {
            scrollOptions = {
                animation: gsap.fromTo(
                    refs.childrenPicture,
                    {
                        x: -1000,
                        opacity: 0,
                    },
                    {
                        duration: 1,
                        x: 0,
                        opacity: 1.0,
                        ease: 'easeGarret',
                    }
                ),
            };
        } else if (el.dataset.skroll === 'split-hero-block-right') {
            scrollOptions = {
                animation: gsap.fromTo(
                    refs.childrenPicture,
                    {
                        x: 1000,
                        opacity: 0,
                    },
                    {
                        duration: 1,
                        x: 0,
                        opacity: 1.0,
                        ease: 'easeGarret',
                    }
                ),
            };
        }

        // Push to scroll elements array
        this.scrollElements.push(new Animation(el, scrollOptions, refs));

        if (refs && refs.parent) {
            refs.parent.setAttribute('data-skroll-index', index);
        }
    }
}
